import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { TokenService } from "../../services/shared/token.service";
import { UserLockService } from "../../services/login/user-lock.service";
import { Observable } from "rxjs";

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenService: TokenService,
    private userLockService: UserLockService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.tokenService.exists('token')) {
      return true;
    }

    this.router.navigate([!this.userLockService.isLocked() ? "/login" : "/lock"]);

    return false;
  }
}
